// header
import { IS_GRIDGIO_MOBILE_VIEW, IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';

export const WEB_HEADER_HEIGHT = '50px';
export const MOBILE_HEADER_HEIGHT = '50px';
export const WEB_SUB_HEADER_HEIGHT = '60px';
export const MOBILE_SUB_HEADER_HEIGHT = '60px';

// footer
export const MOBILE_BOTTOM_HEIGHT = '60px';

//************************* side navigation *************************//
export const WEB_SIDE_WIDTH = '200px';
export const GRIDGIO_SIDE_WIDTH = '60px';
export const MOBILE_SIDE_WIDTH = '250px';
export const HIDDEN_SIDE_WIDTH = '50px';
export const FOOTER_HEIGHT = '140px';
export const NEXT_BUTTON_HEIGHT = '72px';
export const DEALER_BUTTON_HEIGHT = '112px';
export const REQUEST_BUTTON_SCROLL_HEIGHT = '110';
// iyagigo
export const IYAGIGO_MOBILE_SIDE_WIDTH = '180px';

// margin
export const MARGIN_1 = '10px';
export const MARGIN_2 = '20px';
export const MARGIN_3 = '30px';
export const MARGIN_4 = '40px';
export const MARGIN_5 = '50px';

// borer
export const BORDER_WIDTH_1 = '1px';
export const BORDER_WIDTH_2 = '2px';
export const BORDER_WIDTH_3 = '3px';
export const BORDER_RADIUS_1 = '5px';
export const BORDER_RADIUS_2 = '10px';
export const BORDER_RADIUS_3 = '15px';
export const BORDER_RADIUS_4 = '20px';
export const BORDER_RADIUS_5 = '25px';

// auth
export const AUTH_BOX_WIDTH = '300px';
export const AUTH_BLOCK_HEIGHT = '35px';
export const AUTH_BLOCK_WIDTH = '100%';

// error
export const ERROR_TEXT_HEIGHT_1 = '25px';
export const ERROR_TEXT_HEIGHT_2 = '40px';

// input
export const INPUT_BLOCK_HEIGHT = '35px';
// button
export const BUTTON_BLOCK_HEIGHT = '35px';

// ############### architecture ###############
export const PAGE_PADDING = IS_IYAGIGO_MOBILE_VIEW ? '15px' : '20px';
export const CONTENT_PADDING = IS_IYAGIGO_MOBILE_VIEW ? '15px' : '20px';
export const TEST_PROBLEM_NAVIGATOR_HEIGHT = '75px';

// ############### common ###############
export const HOVER_TRANSLATE = 'translateY(-1px)';

// ############### modal ###############
export const LARGE_MODAL_WIDTH = IS_IYAGIGO_MOBILE_VIEW ? '250px' : '350px';
export const GRIDGIO_LARGE_MODAL_WIDTH = IS_GRIDGIO_MOBILE_VIEW ? '250px' : '350px';
export const MEDIUM_MODAL_WIDTH = IS_IYAGIGO_MOBILE_VIEW ? '250px' : '250px';
export const MODAL_SCROLL_HEIGHT = IS_IYAGIGO_MOBILE_VIEW ? '300px' : '300px';
export const TOAST_HEIGHT = '60vh';
export const TOAST_PADDING = `0 ${MARGIN_2} 0 ${MARGIN_2}`;
// export const TOAST_PADDING = `0 ${MARGIN_2} ${MARGIN_2} ${MARGIN_2}`;

// ############### design system button ###############
export const DESIGN_SYSTEM_BUTTON_SMALL_HEIGHT = '25px';
export const DESIGN_SYSTEM_BUTTON_MEDIUM_HEIGHT = '35px';
export const DESIGN_SYSTEM_BUTTON_LARGE_HEIGHT = '45px';
export const DESIGN_SYSTEM_BUTTON_SMALL_PADDING_X = '8px';
export const DESIGN_SYSTEM_BUTTON_MEDIUM_PADDING_X = '12px';
export const DESIGN_SYSTEM_BUTTON_LARGE_PADDING_X = '16px';
export const DESIGN_SYSTEM_BUTTON_BORDER_WIDTH = '1px';
export const DESIGN_SYSTEM_BUTTON_BORDER_RADIUS = '10px';

// ############### island ###############
export const ISLAND_WIDTH = '600px';

// 손글씨 기준 좌표계의 선 두께
export const DESIGN_SYSTEM_HANDWRITING_SMALL_STROKE_WIDTH = 1.8;
export const DESIGN_SYSTEM_HANDWRITING_MEDIUM_STROKE_WIDTH = 2.4;
export const DESIGN_SYSTEM_HANDWRITING_LARGE_STROKE_WIDTH = 3.2;

